export default __webpack_public_path__ + "static/media/IMG_0462.cc91bd0d.jpg";